__turbopack_context__.v({
  "membershipLine": "DKAgreementMembershipLine-module-scss-module__JElHLa__membershipLine",
  "prefix": "DKAgreementMembershipLine-module-scss-module__JElHLa__prefix",
});
